import React from 'react';
import { C } from '../../shared/design-tokens.js';

const INPUT = {
  width: '100%',
  padding: '10px 14px',
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: 8,
  color: '#fff',
  fontSize: 14,
  fontFamily: 'Montserrat, Arial, sans-serif',
  outline: 'none',
};

const LABEL = {
  fontSize: 11,
  color: 'rgba(255,255,255,0.4)',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginBottom: 6,
  display: 'block',
};

interface Terminal {
  id: string | number;
  name?: string;
  label?: string;
}

interface DirectoryFiltersProps {
  terminals: Terminal[];
  search: string;
  statusFilter: string;
  terminalFilter: string;
  staffingFilter: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onTerminalChange: (value: string) => void;
  onStaffingChange: (value: string) => void;
}

export default function DirectoryFilters({
  terminals,
  search,
  statusFilter,
  terminalFilter,
  staffingFilter,
  onSearchChange,
  onStatusChange,
  onTerminalChange,
  onStaffingChange,
}: DirectoryFiltersProps) {
  return (
    <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
      <div>
        <label style={LABEL}>Search</label>
        <input
          type="text"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search employees..."
          style={INPUT}
        />
      </div>

      <div>
        <label style={LABEL}>Status</label>
        <select value={statusFilter} onChange={(event) => onStatusChange(event.target.value)} style={INPUT}>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="terminated">Terminated</option>
          <option value="on_leave">On Leave</option>
          <option value="">All statuses</option>
        </select>
      </div>

      <div>
        <label style={LABEL}>Terminal</label>
        <select value={terminalFilter} onChange={(event) => onTerminalChange(event.target.value)} style={INPUT}>
          <option value="">All terminals</option>
          {terminals.map((terminal: Terminal) => (
            <option key={terminal.id} value={terminal.id}>{terminal.name || terminal.label || terminal.id}</option>
          ))}
        </select>
      </div>

      <div>
        <label style={LABEL}>Staffing</label>
        <select value={staffingFilter} onChange={(event) => onStaffingChange(event.target.value)} style={INPUT}>
          <option value="">All staffing</option>
          <option value="local">Local</option>
          <option value="contingent">Contingent</option>
          <option value="lead">Lead</option>
          <option value="traveling_manager">Traveling Manager</option>
          <option value="admin">Admin</option>
          <option value="local_manager">Local Manager</option>
        </select>
      </div>

      <div style={{ alignSelf: 'end', fontSize: 12, color: C.textMuted }}>
        Read-only V2 grid slice
      </div>
    </div>
  );
}
